/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { useNavigate } from 'react-router-dom'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Button, LFB } from '@nexigendigital/nxui'

import { useSelectMethodMutation } from 'api/app'

import { TwoFactorMethod } from 'models/authentication'

/**********************************************************************************************************
 *   STYLE IMPORTS
 **********************************************************************************************************/
import { TwoFactorRecovery } from './form.style'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function SelectMethod() {
    const navigate = useNavigate()
    const [methodList, setMethodList] = useState<TwoFactorMethod[]>([])
    const [selectMethod, { isLoading: isSelectMethodLoading, isSuccess: isSelectMethodSuccess, data: selectMethodData }] = useSelectMethodMutation()
    const {
        appAuthentication: { twofactor: { backup: twoFactorBackups } }
    } = useAppSelector((state) => state.app)

    /****************************************************
     *  FUNCTIONS
     ****************************************************/

    function renderMethodLabel(type: string, identifier: string) {
        switch (type) {
            case 'sms':
                return {
                    title: 'Mobile Verification',
                    desc: `Receive an SMS with an authentication code to ${identifier}`
                }

            case 'email':
                return {
                    title: 'Email Verification',
                    desc: `Receive an email with an authentication code to ${identifier}`
                }

            case 'authenticator':
            default:
                return {
                    title: 'App Verification',
                    desc: 'Use your authentication app to receive a code'
                }
        }
    }

    useEffect(() => {
        if (twoFactorBackups && twoFactorBackups.length > 1) setMethodList(twoFactorBackups!.filter((method: TwoFactorMethod) => !method.is_primary))
    }, [twoFactorBackups, setMethodList])

    useEffect(() => {
        if (isSelectMethodSuccess && selectMethodData) {
            navigate('/two-factor', { replace: true })
        }
    }, [isSelectMethodSuccess, selectMethodData])

    /****************************************************
     *  COMPONENT RENDER
     ****************************************************/
    return (
        <>
            <TwoFactorRecovery.Container>
                {methodList.map(({ type, identifier }) => {
                    const details = renderMethodLabel(type, identifier)
                    return <LFB key={type} loading={isSelectMethodLoading} label={details.title} description={details.desc} onClick={() => selectMethod(type)} />
                })}
            </TwoFactorRecovery.Container>
            <TwoFactorRecovery.Footer>
                <Button type={'button'} color={'secondary'} onClick={() => navigate('/login/two-factor')}>Back</Button>
            </TwoFactorRecovery.Footer>
        </>
    )
}
